import { MainContentWrapper } from '@ydistri/ds';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { setSubpage } from '../../../routes/routerSlice';
import { useAppDispatch } from '../../../store';
import { ProjectAdministrationSubpage } from '../projectAdministrationLib';
import StoresScheduleSection from './StoresScheduleSection';

const StoresScheduleAdministration: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSubpage(ProjectAdministrationSubpage.STORES_SCHEDULE));
  }, [dispatch]);

  return (
    <>
      <Helmet title="Stores Schedule Administration" />
      <MainContentWrapper>
        <StoresScheduleSection />
      </MainContentWrapper>
    </>
  );
};

export default StoresScheduleAdministration;
